import { render, staticRenderFns } from "./SelectColumn.vue?vue&type=template&id=7222f020&scoped=true"
import script from "./SelectColumn.vue?vue&type=script&lang=js"
export * from "./SelectColumn.vue?vue&type=script&lang=js"
import style0 from "./SelectColumn.vue?vue&type=style&index=0&id=7222f020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7222f020",
  null
  
)

export default component.exports